import { render, staticRenderFns } from "./ResaltarTexto.vue?vue&type=template&id=06a49208"
import script from "./ResaltarTexto.vue?vue&type=script&lang=js"
export * from "./ResaltarTexto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06a49208')) {
      api.createRecord('06a49208', component.options)
    } else {
      api.reload('06a49208', component.options)
    }
    module.hot.accept("./ResaltarTexto.vue?vue&type=template&id=06a49208", function () {
      api.rerender('06a49208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ResaltarTexto.vue"
export default component.exports